import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	expenseProject: null,
	error: "",
	loading: false,
};

// ADD_rate
export const addExpenseProject = createAsyncThunk(
	"expenseProject/addExpenseProject",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `expenseProject`,
				data: {
					...values,
				},
			});
			toast.success("Project added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Project try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_rate
export const deleteExpenseProject = createAsyncThunk(
	"expenseProject/deleteExpenseProject ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `expenseProject/${id}`,
			});

			toast.success("Project deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting expenseProject try again");
			// console.log(error.message);
		}
	}
);


// expenseProject
export const getAllExpenseProject = createAsyncThunk(
	"expenseProject/getAllExpenseProject",
	async () => {
		try {
			const { data } = await axios.get(`expenseProject`);
			return data;
		} catch (error) {
			// console.log(error.message);
		}
	}
);

export const updateExpenseProject = createAsyncThunk(
	"expenseProject/updateExpenseProject",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `expenseProject/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Project updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Project try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const expenseProjectSlice = createSlice({
	name: "expenseProject",
	initialState,
	reducers: {
		clearExpenseProject: (state) => {
			state.expenseProject = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllExpenseProject ======

		builder.addCase(getAllExpenseProject.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllExpenseProject.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllExpenseProject.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addExpenseProject  ======

		builder.addCase(addExpenseProject.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addExpenseProject.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addExpenseProject.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for expenseProject ======

		builder.addCase(updateExpenseProject.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateExpenseProject.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateExpenseProject.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteExpenseProject  ======

		builder.addCase(deleteExpenseProject.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteExpenseProject.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteExpenseProject.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default expenseProjectSlice.reducer;
export const { clearExpenseProject } = expenseProjectSlice.actions;
